export const queryKeys = {
  TABLE_KEY: (key?: string | null) => `TABLE_KEY_${key}`,
  TABLE_ALL: 'TABLE_ALL'
};
